module.exports = {
  slug: 'antisound',
  name: 'Antisound',
  links: [],
}
